import styled from 'styled-components';

export const NoSearchResultsWrapper = styled.div`
  text-align: center;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
